export const DEFAULT_POPPER_PROPS = {
    position: 'end',
    preventOverflow: true,
};
//# sourceMappingURL=popper-default.js.map